/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Typography,
  Tooltip,
  FormControl,
  Select,
  TextField,
  MenuItem,
  IconButton,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { clearAssembliesList } from "slices/assembliesSlice";
import { setAssemblyFilters } from "slices/filtersSlice";

import { clearAssembliesPagination } from "slices/paginationSlice";

import { useTheme } from "@emotion/react";

const AssembliesContent = ({ ...props }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [btnStyleAssembly, setBtnStyleAssembly] = useState(0);
  const [btnStyleOad, setBtnStyleOad] = useState(0);

  const [assemblyFilterState, setAssemblyFilterState] = useState({
    assemblyStatus: null,
    oadUpdateStatus: null,
    startDate: null,
    endDate: null,
    pcbType: null,
  });

  const assemblyFilters = useSelector(
    (state) => state.filtersState.assemblyFilters
  );

  const handleChangePcbType = (event) => {
    let pcbType = event.target.value;
    setAssemblyFilterState({
      ...assemblyFilterState,
      pcbType: pcbType,
    });
  };

  const handleChangeAssemblies = (event) => {
    event.persist();

    setAssemblyFilterState((prevFilteredState) => ({
      ...prevFilteredState,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    if (props.openMobile && props.onMobileClose) {
      props.onMobileClose();
    }

    // eslint-disable-next-line
  }, []); //??

  useEffect(() => {
    dispatch(clearAssembliesList());
    dispatch(clearAssembliesPagination());
    dispatch(
      setAssemblyFilters({
        ...assemblyFilters,
        assemblyStatus: assemblyFilterState.assemblyStatus,
        oadUpdateStatus: assemblyFilterState.oadUpdateStatus,
        startDate: assemblyFilterState.startDate,
        endDate: assemblyFilterState.endDate,
        pcbType:
          assemblyFilterState.pcbType === "ALL"
            ? null
            : assemblyFilterState.pcbType,
      })
    );
  }, [
    dispatch,
    clearAssembliesList,
    setAssemblyFilters,
    clearAssembliesPagination,
    assemblyFilterState,
  ]);

  const handleChangeAssemblys = (result) => {
    if (result === "ALL") {
      result = null;
      setBtnStyleAssembly(0);
    } else if (result === "SUCCESS") {
      result = 1;
      setBtnStyleAssembly(1);
    } else {
      result = 0;
      setBtnStyleAssembly(2);
    }

    setAssemblyFilterState({
      ...assemblyFilterState,
      assemblyStatus: result,
    });
  };

  const handleChangeOADStatus = (result) => {
    if (result === "ALL") {
      result = null;
      setBtnStyleOad(0);
    } else if (result === "TRUE") {
      result = true;
      setBtnStyleOad(1);
    } else {
      result = false;
      setBtnStyleOad(2);
    }

    setAssemblyFilterState({
      ...assemblyFilterState,
      oadUpdateStatus: result,
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        "& > *": {
          margin: theme.spacing(1),
        },
      }}
    >
      <Typography variant="h6" gutterBottom style={{ margin: "10px 0" }}>
        <br />
        OAD Update Status
      </Typography>
      <ButtonGroup
        size="small"
        variant="contained"
        aria-label="outlined small button group"
      >
        <Button
          children="ALL"
          color={btnStyleOad === 0 ? "primary" : ""}
          onClick={() => {
            handleChangeOADStatus("ALL");
          }}
        />
        <Button
          children="SUCCESS"
          color={btnStyleOad === 1 ? "primary" : ""}
          onClick={() => {
            handleChangeOADStatus("TRUE");
          }}
        />
        <Button
          children="FAILURE "
          color={btnStyleOad === 2 ? "primary" : ""}
          onClick={() => {
            handleChangeOADStatus("FALSE");
          }}
        />
      </ButtonGroup>
      <Typography variant="h6" gutterBottom style={{ margin: "10px 0" }}>
        <br />
        Last PCBA Test Status
      </Typography>
      <ButtonGroup
        size="small"
        variant="contained"
        aria-label="outlined small button group"
      >
        <Button
          children="ALL"
          color={btnStyleAssembly === 0 ? "primary" : ""}
          onClick={(event) => {
            handleChangeAssemblys("ALL");
          }}
        />
        <Button
          children="SUCCESS"
          color={btnStyleAssembly === 1 ? "primary" : ""}
          onClick={(event) => {
            handleChangeAssemblys("SUCCESS");
          }}
        />
        <Button
          children="FAILURE"
          color={btnStyleAssembly === 2 ? "primary" : ""}
          onClick={(event) => {
            handleChangeAssemblys("FAILURE");
          }}
        />
      </ButtonGroup>

      <Typography variant="h6" gutterBottom style={{ margin: "0px 0" }}>
        <br />
        Date
        <Tooltip
          arrow
          title={
            "Filters assemblies by the most recent calibration test date. " +
            "If no assembly test is available, the assemblies are " +
            "filtered by their last modification time."
          }
        >
          <IconButton size="large">
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      </Typography>

      <TextField
        id="date"
        label="From"
        variant="outlined"
        type="date"
        name="startDate"
        onChange={handleChangeAssemblies}
        defaultValue="2018-05-05"
        sx={{
          marginTop: "10px",
          backgroundColor: "#f5f5f5",
          borderRadius: "4px",
          marginTop: theme.spacing(3),
          width: 150,
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        id="date"
        label="To"
        name="endDate"
        variant="outlined"
        type="date"
        onChange={handleChangeAssemblies}
        defaultValue={`${props.today}`}
        sx={{ marginTop: theme.spacing(3), width: 150 }}
        InputLabelProps={{
          shrink: true,
        }}
        style={{ backgroundColor: "#f5f5f5" }}
      />
      <Typography
        variant="h6"
        gutterBottom
        style={{ margin: "10px 0", marginTop: "15px" }}
      >
        <br />
        Product
      </Typography>
      <FormControl
        variant="outlined"
        style={{
          backgroundColor: "#f5f5f5",
          minWidth: 150,
          maxWidth: 200,
        }}
      >
        <Select
          value={assemblyFilterState.pcbType ?? "ALL"}
          onChange={handleChangePcbType}
          inputProps={{
            name: "pcbType",
          }}
        >
          <MenuItem value="ALL">ALL</MenuItem>
          <MenuItem value="SPIROHOME">
            SPIROHOME PERSONAL, SPIROHOME CLINIC AND SPIROCLINIC COMPACT
          </MenuItem>
          <MenuItem value="SPIROCLINIC_PRO_HANDPIECE">
            SPIROCLINIC PRO HANDPIECE
          </MenuItem>
          <MenuItem value="SPIROCLINIC_PRO_DOCK">SPIROCLINIC PRO DOCK</MenuItem>
          <MenuItem value="ISPIRO">ISPIRO ULTRASONIC</MenuItem>
          <MenuItem value="ISPIRO_PRO">ISPIRO PRO</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default AssembliesContent;
